export default "__VITE_ASSET__CUz0Lnqp__"